this["tib"] = this["tib"] || {};
this["tib"]["blogTemplate"] = this["tib"]["blogTemplate"] || {};

this["tib"]["blogTemplate"]["public/blog-entry"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n    <div class=\"row app-translate-15\">\n        <div class=\"col-sm-12\">\n            <div class=\"blog-entry-full blog-entry-full-title\">\n                <p id=\"blog-entry-full-title-value\">"
    + escapeExpression(((stack1 = ((stack1 = depth0.BlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.Title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n            </div>\n            <div class=\"blog-entry-full blog-entry-full-title\">\n                <p><a class=\"blog-entry-full-link-back\">BACK</a></p>\n            </div>\n            <div class=\"blog-entry-full\">\n                <div class=\"blog-entry-full-content\">";
  stack2 = ((stack1 = ((stack1 = depth0.BlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.Content)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "</div>\n                <div class=\"blog-entry-full-footer\">\n                    <p>"
    + escapeExpression(((stack1 = ((stack1 = depth0.BlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.Author)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n                    <p>"
    + escapeExpression(((stack1 = ((stack1 = depth0.BlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.CreatedDate)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n                </div>\n            </div>\n            <div class=\"blog-entry-full blog-entry-full-title\">\n                <p><a class=\"blog-entry-full-link-back\" href=\"/blog.php\">BACK</a></p>\n            </div>\n        </div>\n    </div>\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, depth0.BlogEntry, {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  });

this["tib"]["blogTemplate"]["public/blog"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing, blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n        ";
  options = {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data};
  if (stack1 = helpers.BlogEntries) { stack1 = stack1.call(depth0, options); }
  else { stack1 = depth0.BlogEntries; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  if (!helpers.BlogEntries) { stack1 = blockHelperMissing.call(depth0, stack1, options); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            <div class=\"row app-translate-15\">\n                ";
  stack1 = helpers.each.call(depth0, depth0, {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </div>\n        ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n                    ";
  options = {hash:{},inverse:self.program(7, program7, data),fn:self.program(4, program4, data),data:data};
  stack2 = ((stack1 = helpers.if_even || depth0.if_even),stack1 ? stack1.call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.index), options) : helperMissing.call(depth0, "if_even", ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.index), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n                ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                        <div class=\"col-sm-6\" style=\"text-align: left !important;\">\n                            <div class=\"blog-entry blog-entry-title\">\n                                <a class=\"blog-entry-link\" data-blog-entry-id=\"";
  if (stack1 = helpers.BlogEntryId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.BlogEntryId; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\"><p>";
  if (stack1 = helpers.Title) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.Title; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p></a>\n                            </div>\n                            <div class=\"blog-entry blog-entry-item\">\n                                <p>";
  if (stack1 = helpers.PreviewContent) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.PreviewContent; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, depth0.IsShortened, {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n                                <div class=\"blog-entry-footer\">\n                                    <p>";
  if (stack1 = helpers.Author) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.Author; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p>\n                                    <p>";
  if (stack1 = helpers.CreatedDate) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.CreatedDate; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p>\n                                </div>\n                            </div>\n                        </div>\n                    ";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                                    <a class=\"blog-entry-link\" data-blog-entry-id=\"";
  if (stack1 = helpers.BlogEntryId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.BlogEntryId; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\"> Read More...</a>\n                                ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                        <div class=\"col-sm-6 margin-fix\">\n                            <div class=\"blog-entry blog-entry-title\">\n                                <a class=\"blog-entry-link\" data-blog-entry-id=\"";
  if (stack1 = helpers.BlogEntryId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.BlogEntryId; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\"><p>";
  if (stack1 = helpers.Title) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.Title; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p></a>\n                            </div>\n                            <div class=\"blog-entry blog-entry-item\">\n                                <p>";
  if (stack1 = helpers.PreviewContent) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.PreviewContent; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, depth0.IsShortened, {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n                                <div class=\"blog-entry-footer\">\n                                    <p>";
  if (stack1 = helpers.Author) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.Author; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p>\n                                    <p>";
  if (stack1 = helpers.CreatedDate) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.CreatedDate; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p>\n                                </div>\n                            </div>\n                        </div>\n                    ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n        <div class=\"row app-translate-15\">\n            <div class=\"col-sm-12\">\n                <div class=\"blog-entry blog-entry-title\">\n                    <a class=\"blog-entry-link\" data-blog-entry-id=\""
    + escapeExpression(((stack1 = ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.BlogEntryId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"><p>"
    + escapeExpression(((stack1 = ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.Title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p></a>\n                </div>\n                <div class=\"blog-entry blog-entry-item\">\n                    <p>"
    + escapeExpression(((stack1 = ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.PreviewContent)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  stack2 = helpers['if'].call(depth0, ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.IsShortened), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "</p>\n                    <div class=\"blog-entry-footer\">\n                        <p>"
    + escapeExpression(((stack1 = ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.Author)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n                        <p>"
    + escapeExpression(((stack1 = ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.CreatedDate)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    ";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                        <a class=\"blog-entry-link\" data-blog-entry-id=\""
    + escapeExpression(((stack1 = ((stack1 = depth0.LastBlogEntry),stack1 == null || stack1 === false ? stack1 : stack1.BlogEntryId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"> Read More...</a>\n                    ";
  return buffer;
  }

  buffer += "<div class=\"container text-center\">\n    <h2 class=\"m-x-auto\"><b>Blog</b></h2>\n    ";
  stack1 = helpers['if'].call(depth0, depth0.BlogEntries, {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, depth0.LastBlogEntry, {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>";
  return buffer;
  });

this["tib"]["blogTemplate"]["public/login-form-redirect"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n    <div class=\"login-form-redirect app-translate-5\" data-transition=\"entrance\">\n        ";
  options = {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data};
  stack2 = ((stack1 = helpers.iff || depth0.iff),stack1 ? stack1.call(depth0, ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSiteAdmin), "||", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSuperAdmin), options) : helperMissing.call(depth0, "iff", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSiteAdmin), "||", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSuperAdmin), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n        ";
  options = {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data};
  stack2 = ((stack1 = helpers.iff || depth0.iff),stack1 ? stack1.call(depth0, ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsRootAdmin), "||", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSuperAdmin), options) : helperMissing.call(depth0, "iff", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsRootAdmin), "||", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSuperAdmin), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n        ";
  options = {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data};
  stack2 = ((stack1 = helpers.iff || depth0.iff),stack1 ? stack1.call(depth0, ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsBlogAdmin), "||", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSuperAdmin), options) : helperMissing.call(depth0, "iff", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsBlogAdmin), "||", ((stack1 = depth0.User),stack1 == null || stack1 === false ? stack1 : stack1.IsSuperAdmin), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n    </div>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "<div><a href=\"basic.php\">Go to Site</a></div>";
  }

function program4(depth0,data) {
  
  
  return "<div><a href=\"admin.php\">Go to Root Admin</a></div>";
  }

function program6(depth0,data) {
  
  
  return "<div><a href=\"blog-admin.php\">Go to Blog Admin</a></div>";
  }

  stack1 = helpers['if'].call(depth0, depth0.User, {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });

this["tib"]["blogTemplate"]["public/login-form"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<li>\n    <form class=\"form\" role=\"form\" method=\"post\" action=\"login\" accept-charset=\"UTF-8\">\n        <div class=\"form-group\">\n            <label class=\"sr-only\" for=\"username\">Username</label>\n            <input type=\"text\" class=\"form-control login-form-user login-text-box\"\n                   id=\"username\" placeholder=\"Username\" required>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"sr-only\" for=\"password\">Password</label>\n            <input type=\"password\" class=\"form-control login-form-password login-text-box\"\n                   id=\"password\" placeholder=\"Password\" required>\n        </div>\n        <div class=\"alert login-form-message\" role=\"alert\"></div>\n        <div class=\"login-form-redirect-container\"></div>\n        <div class=\"form-group\">\n            <button type=\"button\" class=\"btn btn-primary btn-block login-form-submit\">Sign in\n            </button>\n            <a class=\"btn login-form-password-recovery-link\" href=\"/password-recovery.php\">\n                Forgot Password?\n            </a>\n        </div>\n    </form>\n</li>\n\n";
  });